<p-button variant="text" severity="link" (click)="openPanel()"><span *ngIf="item.use_icon" class="create-button-icon">
  <i [ngClass]="item.icon || 'fas fa-cog'"></i>
</span> {{item.translation_key_page_button||item?.button_label||'page_settings'| translation|translationFromString | transformText :item?.text_transform_key_page_button}}</p-button>
